// error-collector.js
const errorLog = []

// Переопределим console.error
const originalConsoleError = console.error
console.error = function (...args) {
  errorLog.push({ type: 'error', message: args.map(String).join(' '), time: new Date().toISOString() })
  originalConsoleError.apply(console, args)
}

// Переопределим console.warn
const originalConsoleWarn = console.warn
console.warn = function (...args) {
  errorLog.push({ type: 'warn', message: args.map(String).join(' '), time: new Date().toISOString() })
  originalConsoleWarn.apply(console, args)
}

// Ошибки на уровне window
window.onerror = function (message, source, lineno, colno, error) {
  errorLog.push({ type: 'onerror', message, source, lineno, colno, stack: error?.stack || null, time: new Date().toISOString() })
}

// Обработка промисов
window.addEventListener('unhandledrejection', function (event) {
  errorLog.push({ type: 'unhandledrejection', message: event.reason?.message || String(event.reason), time: new Date().toISOString() })
})

export function getErrors() {
  return [...errorLog]
}

export function clearErrors() {
  errorLog.length = 0
}
